<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<h1 class="left"><a href="#/005toc#dedication"><span class="green-1">DEDICATION</span></a></h1>
<p class="noindent"><span class="green"><em>For the four generations of my bread-baking and bread-loving family and for Jeff, who baked real good bread</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003dedication.vue?96ab077c